import { Year } from "../time";
/**
 * 2020 2021 などの形式のYearを扱うえるようにするスキーマ
 */
const StringifyYearSchema = Year.stringSchema.pipe(Year.schema);
export const StringifyYear = {
    schema: StringifyYearSchema,
};
//# sourceMappingURL=stringify-year.js.map